import React from 'react'
import LockIcon from '@material-ui/icons/Lock'
import { makeStyles, Alert, Typography } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(3, 2)
  },
  card: {
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.borderRadius?.md ?? 8,
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(3),
    width: '100%',
    maxWidth: 400,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: theme.spacing(1.5)
  },
  iconWrapper: {
    width: 64,
    height: 64,
    borderRadius: '50%',
    backgroundColor: theme.paintscout.palette.semantic.Warning.S95,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(0.5)
  },
  lockIcon: {
    fontSize: 32,
    color: theme.paintscout.palette.semantic.Warning.S80
  },
  title: {
    color: theme.paintscout.palette.brand.Neutral.P30
  },
  description: {
    marginBottom: theme.spacing(1),
    color: theme.paintscout.palette.brand.Neutral.P30
  },
  alert: {
    textAlign: 'left'
  }
}))

export default function PainterAccessProhibited() {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.card}>
        <div className={classes.iconWrapper}>
          <LockIcon className={classes.lockIcon} />
        </div>
        <Typography variant="h3" className={classes.title}>
          Your access has been paused
        </Typography>
        <Typography variant="body1" className={classes.description}>
          The account owner has paused access to this feature. You won&apos;t be able to use PaintScout until your
          access is restored.
        </Typography>
        <Alert className={classes.alert} severity="info">
          If this seems like a mistake, reach out to the person who set up your account for more information.
        </Alert>
      </div>
    </div>
  )
}
